/** FAQ, Support, and Advertising page copy (Latvian). */
export const pagesMessagesLv = {
  faq: {
    pageTitle: "Biežāk uzdotie jautājumi",
    pageSubtitle: "Atrodiet atbildes uz biežāk uzdotajiem jautājumiem par WasOK",
    seoTitle: "BUJ — WasOK",
    seoDescription:
      "Atbildes uz biežāk uzdotajiem jautājumiem par WasOK, produktu skenēšanu, privātumu un vērtējumiem.",
    items: [
      {
        question: "Kā darbojas WasOK?",
        answer:
          "WasOK palīdz jums atcerēties, kuri produkti jums patika vai nepatika, skenējot svītrkodus un saglabājot jūsu vērtējumus un piezīmes. Vienkārši noskenējiet produkta svītrkodu, novērtējiet to, pievienojiet piezīmes, un nākamreiz, skenējot to pašu produktu, uzreiz redzēsiet savu iepriekšējo atsauksmi.",
      },
      {
        question: "Vai mani dati tiek glabāti mākonī?",
        answer:
          "Nē! Visi jūsu dati tiek glabāti lokāli jūsu ierīcē. Mēs nesinhronizējam jūsu informāciju ar mākoni, tāpēc jūsu iepirkumu vēsture un viedokļi par produktiem paliek pilnībā privāti. Tomēr tas arī nozīmē, ka jums vajadzētu izveidot ierīces dublējumu, ja vēlaties saglabāt savus datus.",
      },
      {
        question: "Vai man ir nepieciešams interneta savienojums, lai lietotu WasOK?",
        answer:
          "Nē, WasOK darbojas pilnībā bezsaistē. Tā kā visi jūsu dati tiek glabāti lokāli jūsu ierīcē, jūs varat skenēt produktus, pievienot vērtējumus un skatīt savu vēsturi bez jebkāda interneta savienojuma.",
      },
      {
        question: "Vai es varu izmantot WasOK jebkura veida produktiem?",
        answer:
          "Jā! WasOK darbojas ar jebkuru produktu, kuram ir svītrkods. Neatkarīgi no tā, vai tas ir pārtikas produkts, kosmētika, mājsaimniecības preces, elektronika vai kaut kas cits ar svītrkodu, jūs varat to noskenēt un saglabāt savu viedokli.",
      },
      {
        question: "Kā noskenēt svītrkodu?",
        answer:
          "Vienkārši atveriet WasOK lietotni un pieskarieties skenēšanas pogai. Vērsiet kameru pret produkta svītrkodu, un lietotne automātiski to atpazīs un noskenēs. Lai iegūtu labākos rezultātus, pārliecinieties, ka svītrkods ir labi izgaismots un fokusā.",
      },
      {
        question: "Vai es varu pievienot fotoattēlus saviem produktu vērtējumiem?",
        answer:
          "Jā! Jūs varat pievienot fotoattēlus jebkuram produkta vērtējumam. Tas ir īpaši noderīgi, lai atcerētos iepakojuma detaļas, sastāvdaļu sarakstus vai jebkuru citu vizuālu informāciju, kas var palīdzēt atcerēties, kāpēc jums produkts patika vai nepatika.",
      },
      {
        question: "Kādu informāciju es varu saglabāt par produktiem?",
        answer:
          "Jūs varat saglabāt vērtējumus (1–5 zvaigznes), teksta piezīmes, fotoattēlus, samaksāto cenu, vietu, kur to iegādājāties, un pielāgotas kategorijas. Šī vispusīgā informācija palīdz jums pieņemt pārdomātus lēmumus iepērkoties.",
      },
      {
        question: "Vai es varu izveidot iepirkumu sarakstus?",
        answer:
          "Jā! WasOK ļauj izveidot iepirkumu sarakstus no produktiem, kurus jau esat novērtējuši. Tas atvieglo atcerēšanos, kuri produkti jums patika un kurus vēlaties iegādāties atkārtoti.",
      },
      {
        question: "Kā organizēt savus produktus?",
        answer:
          "Jūs varat organizēt produktus, izmantojot pielāgotas kategorijas. Piemēram, varat izveidot tādas kategorijas kā „Uzkodas“, „Kafija“, „Ādas kopšana“ vai „Tīrīšanas līdzekļi“. Tas atvieglo vērtējumu pārlūkošanu pēc veida.",
      },
      {
        question: "Vai WasOK ir bezmaksas?",
        answer:
          "Jā, WasOK ir pilnībā bezmaksas lejupielādei un lietošanai. Nav nekādu pirkumu lietotnē, abonementu vai slēptu maksu. Mēs uzskatām, ka ikvienam vajadzētu būt pieejamam privātam veidam, kā atcerēties savas produktu vēlmes.",
      },
      {
        question: "Vai WasOK ir pieejama cilvēkiem ar īpašām vajadzībām?",
        answer:
          "WasOK ir izstrādāta tā, lai to varētu izmantot pēc iespējas vairāk cilvēku. Lietotnē ir pieejamības funkcijas, piemēram, ekrāna lasītāja atbalsts, mērogojams teksts un izvēles augsta kontrasta režīms.",
      },
      {
        question: "Kas notiek, ja es atinstalēju lietotni?",
        answer:
          "Tā kā visi dati tiek glabāti lokāli jūsu ierīcē, atinstalējot lietotni, tiks izdzēstas visas jūsu produktu atsauksmes, piezīmes un iepirkumu saraksti. Pirms atinstalēšanas noteikti eksportējiet savus datus, ja vēlaties saglabāt dublējumu.",
      },
      {
        question: "Vai es varu eksportēt savus datus?",
        answer:
          "Jā, WasOK ļauj eksportēt savus datus dublēšanas nolūkos. Jūs varat eksportēt visas savas atsauksmes failā, ko varat saglabāt savā ierīcē vai izvēlētajā mākoņa krātuvē.",
      },
      {
        question: "Vai WasOK izseko manu atrašanās vietu?",
        answer:
          "Nē, WasOK neizseko jūsu atrašanās vietu. Lai gan jūs varat manuāli ievadīt veikala nosaukumu, kur iegādājāties produktu, lietotne neizmanto GPS vai atrašanās vietas pakalpojumus.",
      },
      {
        question: "Vai es varu izmantot WasOK vairākās ierīcēs?",
        answer:
          "Pašlaik WasOK nesinhronizē datus starp ierīcēm, jo visi dati tiek glabāti lokāli. Katrai ierīcei būs sava atsevišķa produktu un atsauksmju datubāze.",
      },
      {
        question: "Ko darīt, ja svītrkods nenoskenējas?",
        answer:
          "Ja svītrkods nenoskenējas, pārliecinieties, ka tas ir labi izgaismots un fokusā. Varat arī mēģināt notīrīt kameras lēcu. Ja svītrkods ir bojāts vai neskaidrs, iespējams, varēsiet ievadīt svītrkoda numuru manuāli.",
      },
    ],
    cta: {
      heading: "Vai jums joprojām ir jautājumi?",
      body: "Sazinieties ar mūsu atbalsta komandu — mēs labprāt palīdzēsim.",
      button: "Sazināties ar atbalstu",
    },
  },
  support: {
    pageTitle: "Atbalsts",
    seoTitle: "Atbalsts — WasOK",
    seoDescription:
      "Saņemiet palīdzību ar WasOK: sazinieties ar atbalstu, ziņojiet par kļūdām un dalieties ar atsauksmēm.",
    getHelp: {
      title: "Saņemiet palīdzību",
      body: "Mēs esam šeit, lai palīdzētu jums izmantot visas WasOK iespējas. Ja jums rodas problēmas vai jautājumi, mums ir vairāki resursi, kas var jums palīdzēt.",
    },
    faq: {
      title: "Biežāk uzdotie jautājumi",
      body: "Pirms sazināties ar mums, apskatiet mūsu BUJ sadaļu, kurā atbildam uz visbiežāk uzdotajiem jautājumiem par WasOK. Tur atradīsiet detalizētu informāciju par to, kā darbojas lietotne, privātumu, datu glabāšanu un citiem jautājumiem.",
    },
    contact: {
      title: "Sazināties ar atbalstu",
      body: "Ja nevarat atrast meklēto atbildi, mūsu atbalsta komanda ir gatava palīdzēt. Jūs varat sazināties ar mums šeit:",
      emailLabel: "E-pasts:",
      responseTime: "Parasti atbildam 24–48 stundu laikā",
    },
    bugs: {
      title: "Ziņošana par kļūdām",
      body: "Atradāt kļūdu? Mēs novērtējam jūsu palīdzību, padarot WasOK labāku. Ziņojot par kļūdu, lūdzu, iekļaujiet:",
      items: [
        "Detalizētu problēmas aprakstu",
        "Soļus problēmas atkārtošanai",
        "Jūsu ierīces modeli un Android versiju",
        "Ekrānuzņēmumus vai ekrāna ierakstus, ja iespējams",
      ],
      sendPrefix: "Sūtiet ziņojumus par kļūdām uz:",
    },
    featureRequests: {
      title: "Funkciju pieprasījumi",
      bodyBefore:
        "Vai jums ir ideja jaunai funkcijai? Mēs labprāt uzzinātu par to! Sūtiet savus ierosinājumus uz",
      bodyAfter:
        ". Lai gan mēs nevaram īstenot katru pieprasījumu, mēs rūpīgi izvērtējam visas atsauksmes, plānojot turpmākos atjauninājumus.",
    },
    knownIssues: {
      title: "Zināmās problēmas",
      body: "Šobrīd mēs zinām par šādām problēmām un strādājam pie to risinājumiem:",
      items: [
        "Daži svītrkodi var neieskenēties vājā apgaismojumā — mēģiniet izmantot lukturīti",
        "Ļoti garu produktu piezīmju saglabāšana vecākās ierīcēs var aizņemt kādu brīdi",
        "Attēlu sīktēli var izskatīties pikseļoti augstas izšķirtspējas ekrānos",
      ],
    },
    appUpdates: {
      title: "Lietotnes atjauninājumi",
      body: "Mēs regulāri izlaižam atjauninājumus ar jaunām funkcijām, uzlabojumiem un kļūdu labojumiem. Noteikti atjauniniet WasOK, izmantojot Google Play veikalu, lai iegūtu jaunākos uzlabojumus.",
    },
    community: {
      title: "Kopiena",
      body: "Pievienojieties mūsu lietotāju kopienai, kas ar WasOK palīdzību pieņem gudrākus iepirkšanās lēmumus. Dalieties padomos, uzdodiet jautājumus un sazinieties ar citiem lietotājiem mūsu sociālo tīklu kanālos.",
    },
    emergency: {
      title: "Ārkārtas atbalsts",
      body: 'Ja saskaraties ar kritisku problēmu, kas neļauj jums izmantot lietotni, lūdzu, atzīmējiet savu e-pastu ar „URGENT“ tēmas rindiņā, un mēs piešķirsim prioritāti jūsu pieprasījumam.',
    },
    cta: {
      heading: "Vai joprojām nepieciešama palīdzība?",
      body: "Mūsu atbalsta komanda ir šeit jums. Nevilcinieties sazināties ar jebkādiem jautājumiem vai bažām.",
      button: "Sazināties pa e-pastu",
    },
  },
  advertising: {
    pageTitle: "Reklāma un monetizācija",
    seoTitle: "Reklāma — WasOK",
    seoDescription: "Kā WasOK pieiet reklāmai un monetizācijai.",
    approach: {
      title: "Mūsu pieeja",
      body: "WasOK mēs uzskatām, ka jūsu iepirkšanās ieradumi un viedokļi par produktiem ir privāti un personiski. Mūsu biznesa modelis atspoguļo šo pamatvērtību.",
    },
    noAds: {
      title: "Bez reklāmām",
      body: "WasOK nerāda nekādas reklāmas. Mēs nekad nerādīsim jums reklāmas, pamatojoties uz produktiem, ko skenējat, vērtējumiem, ko sniedzat, vai jebkādiem citiem datiem, ko izveidojat lietotnē. Jūsu pieredze ar WasOK ir pilnībā bez reklāmām.",
    },
    noDataSelling: {
      title: "Datu nepārdošana",
      body: "Mēs nepārdodam, neizīrējam un nedalāmies ar jūsu datiem ar reklāmdevējiem, datu brokeriem vai jebkurām trešajām pusēm. Tā kā visi jūsu dati tiek glabāti lokāli jūsu ierīcē, mums pat nav tiem piekļuves. Jūsu produktu atsauksmes, iepirkumu saraksti un piezīmes pieder tikai jums.",
    },
    noTracking: {
      title: "Bez izsekošanas",
      body: "WasOK neizmanto izsekošanas pikseļus, analītikas pakalpojumus vai jebkādu citu tehnoloģiju, kas uzrauga jūsu uzvedību vai dalās informācijā ar trešajām pusēm. Mēs neizsekojam, kādus produktus skenējat, kuros veikalos iepērkaties vai kā izmantojat lietotni.",
    },
    sustainability: {
      title: "Kā mēs saglabājam ilgtspēju",
      body: "Jūs varētu jautāt, kā mēs uzturam WasOK bezmaksas bez reklāmām vai datu pārdošanas. Mūsu pieeja ir vienkārša:",
      items: [
        {
          label: "Bezmaksas un atvērta:",
          text: "WasOK ir bezmaksas ikvienam, bez prēmijas līmeņiem vai maksas barjerām",
        },
        {
          label: "Ekonomiska darbība:",
          text: "Mēs uzturam zemas izmaksas, veidojot efektīvu, uz privātumu vērstu programmatūru",
        },
        {
          label: "Neobligāti ziedojumi:",
          text: "Lietotāji, kuri mīl WasOK, var mūs atbalstīt ar brīvprātīgiem ziedojumiem",
        },
        {
          label: "Atvērtais kods:",
          text: "Mēs varam piedāvāt konsultāciju vai pielāgotas izstrādes pakalpojumus organizācijām",
        },
      ],
    },
    noAffiliate: {
      title: "Bez partnerības saitēm",
      body: "WasOK neizmanto partnerības saites un nesaņem komisijas no mazumtirgotājiem. Kad jūs skenējat produktu, mēs nenovirzām jūs to iegādāties nekur. Lietotne ir paredzēta tikai jūsu personīgai uzskaitei un lēmumu pieņemšanai.",
    },
    noPromotions: {
      title: "Bez produktu reklamēšanas",
      body: "Mēs nepieņemam maksājumus no zīmoliem vai ražotājiem par viņu produktu reklamēšanu. WasOK nekad neieteiks produktus, neizcels noteiktus zīmolus un nekādā veidā neietekmēs jūsu vērtējumus. Jūsu viedokļi pieder tikai jums.",
    },
    partnerships: {
      title: "Trešo pušu partnerības",
      body: "WasOK nesadarbojas ar mārketinga uzņēmumiem, datu apkopotājiem vai reklāmas tīkliem. Mēs darbojamies neatkarīgi un pāri visam citam izvirzām jūsu privātumu.",
    },
    future: {
      title: "Nākotnes plāni",
      body: "Mēs esam apņēmušies saglabāt WasOK bez reklāmām un ar fokusu uz privātumu. Ja nākotnē mums kādreiz būs nepieciešams ieviest ilgtspējīgu biznesa modeli, mēs:",
      items: [
        "Paziņosim par jebkādām izmaiņām savlaicīgi",
        "Nekad neupurēsim privātumu vai datu drošību",
        "Vienmēr piedāvāsim veidu, kā lietot lietotni bez izsekošanas vai reklāmām",
        "Klausīsimies lietotāju atsauksmēs un bažās",
      ],
    },
    supporting: {
      title: "WasOK atbalstīšana",
      body: "Ja jūs mīlat WasOK un vēlaties atbalstīt mūsu misiju par privātumu vērstas iepirkšanās atmiņas jomā, jūs varat:",
      items: [
        "Pastāstīt draugiem un ģimenei par lietotni",
        "Atstāt pozitīvu atsauksmi Google Play veikalā",
        "Dalīties ar mums savās atsauksmēs un ieteikumos",
        "Apsvērt brīvprātīga ziedojuma veikšanu (kad tas ir pieejams)",
      ],
    },
    cta: {
      heading: "Jautājumi par mūsu politikām?",
      body: "Mēs esam pārskatāmi par to, kā darbojas WasOK. Ja jums ir kādi jautājumi par mūsu pieeju privātumam, monetizācijai vai ilgtspējai, lūdzu, sazinieties ar mums.",
      button: "Sazināties ar mums",
    },
  },
};
